export const NEW_CLIENT_BOOKED_VIEWED_KEY = 'new-client-modal-view-ids';
export const UNADJUDICATED_APPOINTMENTS = 'provider_ncdc_appointments_to_adjudicate';
export const ADJUDICATED_APPOINTMENTS = 'provider_ncdc_appointments_adjudicated';
